/* eslint-disable @typescript-eslint/naming-convention */
import { useOutletContext } from 'react-router-dom'
import { useComputed, useSignal } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Table from 'react-bootstrap/Table'

import Loadable from '../../../../components/Loadable.jsx'
import LoadingAnimation from '../../../../components/LoadingAnimation.jsx'
import SelectParentBusinessEntityLeaf from '../../components/SelectParentBusinessEntityLeaf.jsx'

import { updateGroup } from '../../../../state/actions/groupActions.js'
import { addNotification, notifyException, NotificationTypes } from '../../../../state/actions/notificationActions.js'

import { businessEntitiesLoadedSignal, businessEntitiesErrorSignal, businessEntityDictionarySignal } from '../../../../state/signals/businessEntitySignals.js'
import { groupSignal, groupLoadedSignal, groupErrorSignal } from '../../../../state/signals/groupSignals.js'

import { abridgedClone, iconForOrgType } from '../../../../utils/utils.js'

const ChangeParentModal = function ({ showSignal, rootBusinessEntity, parentBusinessEntityComputed}) {

	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData } = useOutletContext()

	if (!parentBusinessEntityComputed.value) {
		throw Error("Attempting to render a ChangeParentModal without passing the current parent business entity")
	}

	const selectedBusinessEntityIdSignal = useSignal(parentBusinessEntityComputed.value.id)

	const cancelChangeParent = function () {
		showSignal.value = false
		selectedBusinessEntityIdSignal.value = parentBusinessEntityComputed.value.id
	}

	const saveChangedParent = function () {
		const f = "saveChangedParent()"
		const parentId = selectedBusinessEntityIdSignal.value
		if (!parentId) {
			throw Error("Selected parent business entity ID is undefined")
		}
		const group = abridgedClone(groupSignal.value, ["debugInfo"])
		group.parentBusinessEntityId = parentId
		updateGroup(group.id, group, config, accessToken).then(
			(group) => {
				console.log("Updated group:")
				console.log(group)
				addNotification(`Changed parent business entity of group ${group.name} to ${parentBusinessEntityComputed.value.name}`, NotificationTypes.SUCCESS, true, "Parent Business Entity Updated")
			}
		).catch(
			(error) => {
				notifyException(error, "Exception changing group's parent business entity")
			}
		).finally(
			() => {
				cancelChangeParent()
			}
		)
	}

	return (
		<Modal id='changeParent' onHide={cancelChangeParent} show={showSignal.value} size="xl">
			<Modal.Header closeButton>
				<Modal.Title>Change Parent</Modal.Title>
			</Modal.Header>
			<Modal.Body className='modal-body modal-table'>
				<Table id='groupParentOrg'>
					<thead></thead>
					<tbody style={{ display:"block", maxHeight: "calc(100vh - 250px)", overflowY:"auto"}}>{
						(businessEntitiesLoadedSignal.value && groupLoadedSignal.value) ? (
							<SelectParentBusinessEntityLeaf
								type="radio"
								businessEntity={rootBusinessEntity}
								selectedBusinessEntityIdSignal={selectedBusinessEntityIdSignal}
								depth={0}
							/>
						) : (<tr><td colSpan={2}><LoadingAnimation /></td></tr>)
					}</tbody>
				</Table>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={cancelChangeParent}>Cancel</Button>
				<Loadable loadedSignals={[businessEntitiesLoadedSignal, groupLoadedSignal]} errorSignals={[businessEntitiesErrorSignal, groupErrorSignal]}>
					<Button onClick={saveChangedParent} disabled={selectedBusinessEntityIdSignal.value == parentBusinessEntityComputed.value.id}>Apply</Button>
				</Loadable>
			</Modal.Footer>
		</Modal>
	)
}
export default ChangeParentModal